import Lottie from "react-lottie";
import React, { Component } from "react";

// import images from '../../../utils/images';
import * as animationData from "./spinner.json";

import "./styles.scss";

const defaultOptions = {
  animationData,
  autoplay: true,
  loop: true,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

class Spinner extends Component {
  render() {
    return (
      <div className="Spinner position-fixed text-dark d-flex align-items-center tw:justify-center">
        {/* <img width="60" src={images('./common/loader.svg')} alt="loader svg" /> */}
        <Lottie height={400} options={defaultOptions} width={400} />
      </div>
    );
  }
}
export default Spinner;
